<app-side-menu [user]="user" [emailFromToken]="emailFromToken" [links]="links$ | async">
  <app-top-bar [user]="user" [emailFromToken]="emailFromToken"></app-top-bar>
  <app-message-list></app-message-list>
  <router-outlet></router-outlet>
</app-side-menu>
